export default class Updater {


  constructor(targetFps) {
    Updater.instance = this;

    this.targetFps = targetFps || 30;
    const list = this._list = [];

    const that = this;

    const lowFPS = 15;
    let lowFPSCount = 0;

    const filterStrength = 15;
    let frameTime = 0, lastLoop = performance.now(), thisLoop;

    function animate() {

      const interval = 1000 / that.targetFps;
      let thisFrameTime = (thisLoop = performance.now()) - lastLoop;
      frameTime += (thisFrameTime - frameTime) / filterStrength;

      if (thisFrameTime > interval) {
        that.fps = Math.ceil(1000 / frameTime);
        const ds = that.targetFps / that.fps;
        // ds = 1;
        that.deltaTime = ds;

        for (let i = 0; i < list.length; ++i) {
          list[i].update(ds);
        }
        if (that.fps < lowFPS) {
          that.lowFPS = true;
          lowFPSCount++;
          if (lowFPSCount == 3) {
            lowFPSCount = 0;
          }
        }
        else {
          that.lowFPS = false;
          lowFPSCount = 0;
        }

      }
      lastLoop = thisLoop - (frameTime % interval);
      if (!that.paused) requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }

  add(element) {
    if (this._list.indexOf(element) != -1) return;
    this._list.push(element);
  }

  remove(element) {
    const index = this._list.indexOf(element);
    if (index != -1) this._list.splice(index, 1);
  }


}



// WEBPACK FOOTER //
// ./src/Updater.js